import script from "./NovelSelector.vue?vue&type=script&setup=true&lang=js"
export * from "./NovelSelector.vue?vue&type=script&setup=true&lang=js"

import "./NovelSelector.vue?vue&type=style&index=0&id=9880dd8a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9880dd8a"]])

export default __exports__